module.exports = __webpack_public_path__ + "static/media/piper-logo-rounded-white.4e37ac1f.svg";